module.exports = "/assets/151fc839aec855a8f811ecd59385544c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MD.png
// module id = 1610
// module chunks = 0